import { render, staticRenderFns } from "./toMyGroupEventManage.vue?vue&type=template&id=2cabf2fc&scoped=true&"
import script from "./toMyGroupEventManage.vue?vue&type=script&lang=js&"
export * from "./toMyGroupEventManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabf2fc",
  null
  
)

export default component.exports